import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { needsBrandSetup } from '@/lib/brandProfile'

const ProtectedRoute: React.FC = () => {
  const { marketer: currentUser, isLoading: loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <div></div>
  }
  if (!currentUser || !currentUser.id) {
    return <Navigate to="/signin" replace />
  }

  // Redirect authenticated users away from sign-in page
  if (currentUser && location.pathname === '/signin') {
    return <Navigate to="/" replace />
  }

  // Marketer must belong to an organization to use the app
  if (!currentUser.org_id && location.pathname !== '/no-organization') {
    return <Navigate to="/no-organization" replace />
  }

  // A brand-new organization sets up its brand before anything else
  // A brand-new organization starts with the intake: four questions, then the Marketplace.
  // The full setup form stays reachable at /setup.
  const setupPaths = ['/welcome', '/setup', '/payments', '/settings', '/help', '/terms']
  if (
    needsBrandSetup((currentUser as any).org) &&
    !setupPaths.some((p) => location.pathname === p || location.pathname.startsWith('/setup'))
  ) {
    return <Navigate to="/welcome" replace />
  }

  return <Outlet />
}

export default ProtectedRoute
